import React from 'react';

import { Router } from './Router';
import { getRoutes } from './routes';
import { useAuthState } from '../AuthState';

export function AppRouter() {
  const { account } = useAuthState();
  const routes = getRoutes(account);
  return <Router routes={routes} />;
}
